import React from "react";
import LogoSvg from "../../Icons/LogoSvg";
import MovableSvg from "services/header/movableSvg";
import MobLogoSvg from "../../Icons/MobLogoSvg";

export default function Logo(props: any) {
  return (
    <>
      <div className="flex lg:hidden ">
        <a href="/" tabIndex={-1}>
          <span className="sr-only">Auction Bazaar</span>
          <MobLogoSvg />
        </a>
      </div>
      <div className="hidden lg:flex">
        <a href="/" tabIndex={-1}>
          <span className="sr-only">Auction Bazaar</span>
          <LogoSvg width="120" height="50" />
        </a>
      </div>
    </>
  );
}
